export const DESKTOP_VENUE_IMAGE_WIDTH = '280px'
export const DESKTOP_VENUE_IMAGE_HEIGHT = '207px'
export const MOBILE_VENUE_IMAGE_HEIGHT = '230px'
export const MOBILE_VENUE_IMAGE_WIDTH = '100%'
export const MAP_VENUE_IMAGE_WIDTH = '80px'
export const MAP_VENUE_IMAGE_HEIGHT = '80px'
